export default __webpack_public_path__ + "static/media/maintenance-item.9c425bdc.svg";